import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface OrderListResponse {
  current_num: number;
  current_page: number;
  page_size: number;
  total: number;
  videos: Array<Order>;
};

export interface Order {
  id: number;
  order_no: string;
  user_id: number;
  pay_platform: string;
  subscription_id: string;
  channel?: string;
  is_renew: number;
  agent_platform?: string;
  agent_code?: string;
  status: number;
  create_time: number;
  update_time: number;
  order_price: number;
  currency: string;
  send_point_val: number;
  user: User;
  order_items: Array<{
    id: number;
    item_id: number;
    order_id: number;
    create_time: number;
  }>;
};

export interface User {
  id: number;
  username: string;
  email: string;
  first_login: boolean;
  region: string;
  registration_source: string;
  status: string;
  avatar: string;
  last_login_at: string;
  last_login_ip: string;
  login_count: number;
  first_dh_create: number;
  in_waiting_queue: number;
  created_type: string;
  last_visit_workspace_id: number;
  agent_admin: number;
  agent_admin_status: number;
  agent_first_login: number;
  device_id: string;
  gender: string;
  company: string;
  personal_title: string;
  is_agent: number;
  user_global_id: string;
  notification_enabled: number;
  admin_name?: string;
  team_ids: string;
  created_at: string;
  updated_at: string;
};


// 请求接口
interface OrderListRequest {
  /** 1 个人订单、2 团队订单 */
  findType: number;
  page?: number;
  pageSize?: number;
}

export class OrderItemData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Item id cannot be empty")
  @IsNumber("Item id must be a number")
  itemId: number;
}

export class UserData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Username cannot be empty")
  @IsString("Username must be a string")
  username: string;
}

export class OrderData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("Order no cannot be empty")
  @IsString("Order no must be a string")
  orderNo: string;

  @Required("Subscription id cannot be empty")
  @IsString("Subscription id must be a string")
  subscriptionId: string;

  @Required("Status cannot be empty")
  @IsNumber("Status must be a number")
  status: number;

  @Required("Create time cannot be empty")
  @IsNumber("Create time must be a number")
  createTime: number;

  @Required("Order price cannot be empty")
  @IsNumber("Order price must be a number")
  orderPrice: number;

  @Required("Currency cannot be empty")
  @IsString("Currency must be a string")
  currency: string;

  @Required("Send point val cannot be empty")
  @IsNumber("Send point val must be a number")
  sendPointVal: number;

  @Required("User cannot be empty")
  user: User;

  @Required("Order items cannot be empty")
  @IsArray("Order items must be an array")
  orderItems: OrderItemData[];
}

export class OrderListData {
  @Required("Order list cannot be empty")
  @IsArray("Order list must be an array")
  data: OrderData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Current page cannot be empty")
  @IsNumber("Current page must be a number")
  currentPage: number;

  @Required("Current num cannot be empty")
  @IsNumber("Current num must be a number")
  currentNum: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;
}

const transformAndValidateOrder = (
  response: OrderListResponse
): OrderListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, OrderListData);
  } catch (error) {
    console.error("Agent data validation failed:", error.message);
    throw error;
  }
};

/** 获取订单列表 */
export const orderList = async ({ findType, page, pageSize }: OrderListRequest): Promise<OrderListData> => {
  const response = await api.post<OrderListResponse>('/order/list', {
    find_type: findType,
    page,
    page_size: pageSize,
  });
  const data = transformAndValidateOrder(response.data);
  return data;
};
